import React from "react"
import styled from "styled-components"

import Card from "./Card"

const StyledTag = styled(Card)`
  text-align: left;
  margin: 10px 0;
  padding: 5px 10px;
  box-shadow: var(--shadow-elavated);
`

const BookName = styled.div`
  font-size: var(--font-regular);
  line-height: var(--line-regular);
  margin-top: 3px;
  margin-bottom: 3px;
`

const Author = styled.div`
  font-size: var(--font-sub);
  line-height: var(--line-sub);
`

type Props = {
  book: string
  author: string
}

const BookTag = ({ book, author }: Props) => {
  return (
    <StyledTag>
      <BookName>{book}</BookName>
      <Author>by {author}</Author>
    </StyledTag>
  )
}

export default BookTag
